import { HttpStatusCode } from 'axios';
import { FC, Fragment, JSX } from 'react';
import { useNavigate } from 'react-router-dom';
import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Button, Grid, Typography } from '@mui/material';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
// components
import { Alert } from 'components/common/Alert';
import CapsuleTypeForm from './CapsuleTypeForm';
import { BackdropLoader } from 'components/common/BackdropLoader';
// Schema, styles, graphql, constants
import { flexCenterBetween } from 'styles/commonComponentStyle';
import { useCreateCapsuleTypeMutation } from 'generated/graphql';
import {
  ADD_TEXT,
  CAPSULE_TYPE_IS_CREATING_TEXT,
  capsuleTypeInitialValue,
  ADD_CAPSULE_TYPE_TEXT,
} from 'constants/index';
import { CapsuleTypeFormType } from 'interfaces';
import { capsuleTypeSchema } from 'validationSchema';

const Add: FC = (): JSX.Element => {
  const navigation = useNavigate();

  const methods = useForm<CapsuleTypeFormType>({
    defaultValues: capsuleTypeInitialValue,
    resolver: yupResolver(capsuleTypeSchema),
  });

  const { handleSubmit } = methods;

  const [createCapsuleType, { loading }] = useCreateCapsuleTypeMutation({
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,

    onCompleted: (data) => {
      const { createCapsuleType } = data;
      const { response } = createCapsuleType || {};
      const { status, message } = response || {};
      if (status === HttpStatusCode.Created) {
        Alert.success(message || '');
        navigation(-1);
      }
    },

    onError: ({ message }) => {
      Alert.error(message);
    },
  });

  const onSubmit: SubmitHandler<CapsuleTypeFormType> = async (data) => {
    const { name, description } = data || {};

    await createCapsuleType({
      variables: {
        createCapsuleTypeInput: {
          name,
          description,
        },
      },
    });
  };

  return (
    <Fragment>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box sx={flexCenterBetween}>
            <Typography variant="h5">{ADD_CAPSULE_TYPE_TEXT}</Typography>
            <Button variant="contained" color="primary" type="submit">
              {ADD_TEXT}
            </Button>
          </Box>
          <Grid container spacing={2}>
            <Grid item lg={6} md={12}>
              <CapsuleTypeForm loading={loading} />
            </Grid>
          </Grid>
        </form>
      </FormProvider>

      <BackdropLoader open={loading} text={CAPSULE_TYPE_IS_CREATING_TEXT} />
    </Fragment>
  );
};

export default Add;
